(() => {
  'use strict';
  if (document.documentElement.dataset.aePurchase !== 'locked') return;

  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  const de = locale === 'de';
  const it = locale === 'it';
  const orderLabel = de ? 'Mit Händlerkonto bestellen' : it ? 'Accedi come rivenditore per ordinare' : 'Wholesale Login to Order';
  const checkoutLabel = de ? 'Händleranmeldung zur Kasse' : it ? 'Accedi come rivenditore per il pagamento' : 'Wholesale Login to Checkout';
  const orderNote = de ? 'Sie können den Katalog ansehen. Melden Sie sich mit Ihrem Händlerkonto an, um zu bestellen.' : it ? 'Puoi consultare il catalogo. Accedi con il tuo account rivenditore per effettuare un ordine.' : 'Catalog browsing is open. Sign in with your wholesale account to place an order.';
  const loginUrl = () => '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
  const purchaseSelector = '[name="add"],[name="checkout"],[data-ae-direct-checkout],.quick-add__submit,.shopify-payment-button button,shopify-accelerated-checkout,shopify-accelerated-checkout-cart';

  function addLoginCta(container, label) {
    if (!container || container.querySelector('.ae-wholesale-login-cta')) return;
    const a = document.createElement('a');
    a.className = 'button button--primary button--full-width ae-wholesale-login-cta';
    a.href = loginUrl();
    a.textContent = label;
    container.appendChild(a);
    if (label === orderLabel) {
      const p = document.createElement('p');
      p.className = 'ae-wholesale-login-note';
      p.textContent = orderNote;
      container.appendChild(p);
    }
  }

  function applyGate(root = document) {
    root.querySelectorAll('.product-form__buttons').forEach(el => addLoginCta(el, orderLabel));
    root.querySelectorAll('.cart__ctas,.cart-notification__links,.drawer__footer').forEach(el => {
      if (el.querySelector('[name="checkout"],.cart__checkout-button')) addLoginCta(el, checkoutLabel);
    });
    root.querySelectorAll(purchaseSelector).forEach(el => {
      if ('disabled' in el) el.disabled = true;
      el.setAttribute('aria-disabled','true');
    });
  }

  document.addEventListener('click', event => {
    const control = event.target.closest(purchaseSelector);
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(loginUrl());
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.action || '';
    const submitter = event.submitter;
    const buying = /\/cart\/add/.test(action) || submitter?.matches?.('[name="checkout"],[name="add"]');
    if (!buying) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(loginUrl());
  }, true);

  new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) applyGate(node);
      }
    }
  }).observe(document.documentElement,{childList:true,subtree:true});

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => applyGate());
  else applyGate();
})();